import React, { FunctionComponent } from 'react';
import { Card, Heading, Text, ScreenReaderText } from '@mlc/web-ui-toolkit';
import { asFormattedDate, asCurrency } from '../../../../common/formatter';
import { Member } from '../../../../../logic/domains/planProfile.domain';
import PolicyCommitteeMembers from './PolicyCommitteeMembers';
import planProfileTestIds from '../PlanProfile.elements';
type Props = {
	balance: number;
	balanceAsOfDate: string;
	expenseReserve: number;
	members: Member[];
};

const PlanBalance: FunctionComponent<Props> = ({
	balance,
	balanceAsOfDate,
	members,
	expenseReserve,
}) => {
	return (
		<Card
			data-id={planProfileTestIds.planBalanceComponent}
			paddingTop={3}
			paddingBottom={3}
			margin={3}
		>
			<ScreenReaderText el="h4">Plan balance</ScreenReaderText>
			<Text
				data-id={planProfileTestIds.planBalanceAsAtDate}
				fontWeight="semibold"
				marginBottom={4}
				marginTop={0}
				el="h5"
			>
				Investor Balances (as at {asFormattedDate(balanceAsOfDate)})
			</Text>
			<Text
				data-id={planProfileTestIds.planBalance}
				fontSize="tiny"
				fontWeight="semibold"
				color="mlcOrange"
				margin={0}
			>
				{asCurrency(balance)}
			</Text>
			{expenseReserve ? (
				<>
					<Text fontWeight="semibold" marginTop={6} marginBottom={4} el="h5">
						Expense reserve account
					</Text>
					<Text
						data-id={planProfileTestIds.planExpenseAccount}
						fontSize="tiny"
						fontWeight="semibold"
						color="mlcOrange"
						margin={0}
					>
						{asCurrency(expenseReserve)}
					</Text>
				</>
			) : null}
			<PolicyCommitteeMembers members={members} />
		</Card>
	);
};
export default PlanBalance;
